import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite/no-important";
import Button from "@material-ui/core/Button";
import Moon from "../packages/Moon";
import Common from "./Common";
import SearchIcon from "@material-ui/icons/Search";
import MyLocation from "@material-ui/icons/MyLocation";
import MenuIcon from "@material-ui/icons/Menu";
import FullScreenIcon from "@material-ui/icons/Fullscreen";
import Categories from "components/Categories";
import SearchResults from "components/SearchResults";
import ZoomSettings from "components/ZoomSettings";
import VisitedItem from "components/VisitedItem";

const styles = {
	sideBarMenu: {
		display: "flex",
		flexDirection: "row",
		flexWrap: "nowrap",
		alignItems: "center",
		justifyContent: "space-evenly"
	}
};

const classes = StyleSheet.create({
	sideBarButton: {
		flex: 1,
		borderRadius: "0px"
	}
});

class SideBar extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			sideBarSelected: Moon.use("category")
		};
	}

	componentWillMount() {
		Moon.addStar(this);
	}

	onClick(selected) {
		this.setState({ sideBarSelected: selected });
	}

	renderSideBarButtons() {
		const selected = this.state.sideBarSelected;
		return (
			<div style={styles.sideBarMenu}>
				<Button
					onClick={() => this.onClick("category")}
					color={selected == "category" ? "secondary" : "black"}
					classes={{
						root: css(classes.sideBarButton)
					}}
				>
					<MenuIcon />
				</Button>
				<Button
					onClick={() => this.onClick("zoom")}
					color={selected == "zoom" ? "secondary" : "black"}
					classes={{
						root: css(classes.sideBarButton)
					}}
				>
					<FullScreenIcon />
				</Button>
				<Button
					onClick={() => this.onClick("search")}
					color={selected == "search" ? "secondary" : "black"}
					classes={{
						root: css(classes.sideBarButton)
					}}
				>
					<SearchIcon />
				</Button>
				<Button
					onClick={() => this.onClick("visitedItem")}
					color={selected == "visitedItem" ? "secondary" : "black"}
					classes={{
						root: css(classes.sideBarButton)
					}}
				>
					<MyLocation />
				</Button>
			</div>
		);
	}

	renderSelectedContent() {
		const selected = this.state.sideBarSelected;
		return (
			<>
				<Categories
					open={selected == "category"}
					openCategory={this.props.openCategory}
				/>
				<ZoomSettings open={selected == "zoom"} />
				<SearchResults open={selected == "search"} />
				<VisitedItem open={selected == "visitedItem"} />
			</>
		);
	}

	render() {
		return (
			<div style={this.props.style}>
				{this.renderSideBarButtons()}
				{this.renderSelectedContent()}
			</div>
		);
	}
}

export default SideBar;
